<template>
  <div class="home-tracks-track col-xs-6 col-md-6 col-lg-3">
    <transition appear name="fade">
        <div class="box" :style="{ 'background-image': `url(${data.image})` }">
          <div class="overlay"></div>
          <div class="playlist-info">
            <span class="playlist" v-text="playlist.title"></span>
            <span class="playlist-line"></span>
            <h3 class="title">{{ data.title }}</h3>
            <p class="by">{{ playlist.by }} {{ data.by }}</p>
            <a :href="data.link" @click="onClickPlaylist" target="_blank">
                <span class="spotify"></span>
                <strong>{{ playlist.action }}</strong>
                <strong>{{ playlist.action }}</strong>
            </a>
          </div>
        </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TracksPlaylist',
  props: ['data'],
  dependencies: ['DATA'],
  data () {
    return {
      playlist: this.DATA.configs.playlist
    }
  },
  methods: {
    onClickPlaylist () {
      fbq('track', 'clickPlaylist', { name: this.data.title });
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../../scss/variables';
  .box {
      height: 20vw;
      background-size: cover;
      background-position: 50% 50%;
      margin-bottom: 36px;
      color: $white;
      padding: 8%;
      position: relative;
  }

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: $black;
    opacity: 0.2;
    top: 0;
    left: 0;
  }

  .playlist {
    position: relative;
    font-size: 15px;
    font-family: $font-bold;
  }

  .playlist-line {
    position: absolute;
    width: 6%;
    height: 2px;
    background: $white;
    left: 0;
    top: 8%;
  }

  .title {
    color: $white !important;
    font-size: 2vw;
    font-family: $font-bold;
    width: 5em;
    position: absolute;
    bottom: 7vw;
  }

  .by {
    position: absolute;
    bottom: 6vw;
    font-size: 16px;
  }

  a {
    border: none;
    color: $white;
    padding: 6% 0;
    font-size: 15px;
    font-family: $font-bold;
    outline: none;
    display: block;
    cursor: pointer;
    position: absolute;
    text-indent: -2em;
    text-align: center;
    text-decoration: none;
    bottom: 1.5vw;
    left: 6%;
    width: 88%;
    transition: color 0.3s linear;

    background: linear-gradient(to bottom, #00ce34 0%, #00ce34 50%, #59ef7f 51%, #59ef7f 100%);
    background-size: 100% 210%;
    transition: background 0.3s $easeOutQuint;

    strong:last-child {
      position: absolute;
      top: 50%;
      left: 0px;
      width: 100%;
      display: block;
      opacity: 0;
      transition: transform 0.3s $easeOutBack, opacity 0.2s linear;
      transform: translate3d(0px, 10px, 0px);
      color: #000;
      opacity: 0;
      pointer-events: none;
    }
    
    strong:first-child {
      transition: transform 0.3s $easeOutBack, opacity 0.2s linear;
      transform: translate3d(0px, 0px, 0px);
      display: block;
      top: 0px;
      position: relative;
    }    


    &:hover {
      background-position: 100% 98%;
      strong:last-child {
        transform: translate(0%, -50%);
        opacity: 1;
      }
      strong:nth-child(2) {
        transform: translate3d(0px, -10px, 0px);
        opacity: 0;
      }      
      .spotify {
        filter: invert(0);
      }
    }
    .spotify {
      background-image: url('/static/images/spotify.svg');
      background-repeat: no-repeat;
      width: 2em;
      height: 2em;
      display: inline-table;
      background-size: cover;
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -1em;
      filter: invert(100%);
      transition: filter 0.3s linear;
    }
  }

  @media screen and (max-width: 1700px) {
    .title {
      bottom: 9vw;
    }
    .by {
      bottom: 6vw;
    }
    a {
      font-size: 13px;
    }
  }

  @media screen and (max-width: 1550px) {
    a {
      font-size: 11px;
    }
  }

  @media screen and (max-width: 1200px) {
    .title {
      bottom: 10vw;
    }
    .by {
      bottom: 8vw;
    }
    a {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 64em) {
    .playlist-line {
      top: 7%;
    }
    .box {
      height: 50vw;
    }
    .title {
      font-size: 5vw;
      bottom: 25vw;
    }
    .by {
      font-size: 2vw;
      bottom: 23vw;
    }
    a {
      bottom: 5vw;
      font-size: 25px;
    }
  }

  @media screen and (max-width: 48em) {
    .playlist {
      font-size: 10px;
    }
    .playlist-line {
      top: 19px;
    }
    .box {
      height: 40vw;
    }
    .title {
      font-size: 3.5vw;
      bottom: 20vw;
    }
    .by {
      font-size: 2vw;
      bottom: 15vw;
    }
    a {
      bottom: 5vw;
      font-size: 10px;
      .spotify {
        width: 1.5em;
        height: 1.5em;
        right: 5px;
        margin-top: -0.8em;
      }
    }
  }

  .fade-enter-active {
    transition: all 1s $easeInOutExpo;
  }
  .fade-enter, .fade-leave-to {
    transform: translateY(-30px);
    filter: grayscale(100%);
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Tracks/Playlist.vue